module.exports = __webpack_public_path__ + "static/media/38.ba81255b.jpg";